// extracted by mini-css-extract-plugin
export default {"user-avatar":"_23PwC","userAvatar":"_23PwC","pixelated":"_2RDgz"};